var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28.3741,
    height: 29,
    rx: 5,
    fill: "#2E71F4",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3438 7.677C10.6771 7.677 7.67712 10.677 7.67712 14.3437C7.67712 18.0103 10.6771 21.0103 14.3438 21.0103C18.0105 21.0103 21.0105 18.0103 21.0105 14.3437C21.0105 10.677 18.0105 7.677 14.3438 7.677ZM14.3438 17.677C13.9438 17.677 13.6771 17.4103 13.6771 17.0103C13.6771 16.6103 13.9438 16.3437 14.3438 16.3437C14.7438 16.3437 15.0105 16.6103 15.0105 17.0103C15.0105 17.4103 14.7438 17.677 14.3438 17.677ZM15.0105 14.3437C15.0105 14.7437 14.7438 15.0103 14.3438 15.0103C13.9438 15.0103 13.6771 14.7437 13.6771 14.3437V11.677C13.6771 11.277 13.9438 11.0103 14.3438 11.0103C14.7438 11.0103 15.0105 11.277 15.0105 11.677V14.3437Z",
    fill: "#2E71F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.db51ef93de721636a701b017b39d05b3.svg";
export { ForwardRef as ReactComponent };